export type TreatmentCoursePatientView = {
  courseId: string | null;
  stepId: string | null;
  edit: boolean;
  journal: boolean;
};

export function readTreatmentCoursePatientParams(
  search: URLSearchParams,
): TreatmentCoursePatientView {
  const courseId = search.get('course')?.trim() || null;
  const stepId = search.get('step')?.trim() || null;
  return {
    courseId,
    stepId: courseId ? stepId : null,
    edit: courseId ? search.get('edit') === '1' : false,
    journal: Boolean(courseId && stepId && search.get('journal') === '1'),
  };
}

export function writeTreatmentCoursePatientParams(
  search: URLSearchParams,
  next: {
    courseId?: string | null;
    stepId?: string | null;
    edit?: boolean;
    journal?: boolean;
  },
): URLSearchParams {
  const params = new URLSearchParams(search);
  params.set('tab', 'treatment_courses');

  const courseId = next.courseId === undefined ? params.get('course') : next.courseId;
  if (courseId) params.set('course', courseId);
  else params.delete('course');

  const stepId = next.stepId === undefined ? params.get('step') : next.stepId;
  if (courseId && stepId) params.set('step', stepId);
  else params.delete('step');

  const edit = next.edit === undefined ? params.get('edit') === '1' : next.edit;
  if (courseId && edit) params.set('edit', '1');
  else params.delete('edit');

  const journal = next.journal === undefined ? params.get('journal') === '1' : next.journal;
  if (courseId && stepId && !edit && journal) params.set('journal', '1');
  else params.delete('journal');

  return params;
}

export function clearTreatmentCoursePatientParams(search: URLSearchParams): URLSearchParams {
  const params = new URLSearchParams(search);
  params.delete('course');
  params.delete('step');
  params.delete('edit');
  params.delete('journal');
  return params;
}

/** Calendar details → patient Behandlingsforløb step workspace. */
export function appointmentCourseStepPath(input: {
  patientId?: string | null;
  courseId?: string | null;
  stepId?: string | null;
}): string | null {
  const patientId = input.patientId?.trim() || null;
  const courseId = input.courseId?.trim() || null;
  const stepId = input.stepId?.trim() || null;
  if (!patientId || !courseId || !stepId) return null;
  const params = writeTreatmentCoursePatientParams(new URLSearchParams(), {
    courseId,
    stepId,
  });
  return `/patients/${patientId}?${params.toString()}`;
}
